export default {
    discount: "/discount",
    bookingActivity: "/activity",
    tax: "/tax",
    registrationFee: "/registrationFee",
    additionalCharge: "/additionalCharge",
    packages: "/packages",
    pricingPacks: "/pricingPacks",
    parentRef: "/parents",
    packageTypeRef: "/packageType",
    ageRangeRef: "/ageRange",
    skillRef: "/skill",
    parents: "/parents",
    student: "/students",
    lastUpdateNotification: "/lastUpdate/notifications",
    lastUpdateTeacher: "/lastUpdate/teacher",
    lastUpdateStudent: "/lastUpdate/student",
    reportRequests: "/reportRequests",
    accounts: "/accounts",
    users: "/users",
    lastUpdateUsers: "/lastUpdate/user",
    lastUpdateAccounts: "/lastUpdate/account",
    activityPost: "/activityPosts",
    timeline: "/timeline",
    publicTimeline: "/publicTimeline",
    participantAttendance: "/participantAttendance",
    instructorAttendance: "/instructorAttendance",
    // The /lastUpdate entries below are the only paths the apps read from the school
    // database; the backend bumps each one whenever its data changes, and the data itself
    // is fetched through the API.
    lastUpdateAttendance: "/lastUpdate/attendance",
    lastUpdateReportRequest: "/lastUpdate/reportRequest",
    lastUpdateParent: "/lastUpdate/parent",
    lastUpdateActivityPost: "/lastUpdate/activityPost",
    lastUpdateActivityPostById: "/lastUpdate/activityPostById",
    lastUpdateActivityTimeline: "/lastUpdate/activityTimeline",
    lastUpdateActivityType: "/lastUpdate/activityType",
    lastUpdateSchoolConfig: "/lastUpdate/schoolConfig",
    lastUpdateAccountStatus: "/lastUpdate/accountStatus"
}